import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import LanguageSelector from "./components/LanguageSelector";
import { trackEvent } from "./utils/metaPixel";
import { trackButtonClick } from "./utils/analytics";
import {
  FiHome,
  FiInfo,
  FiStar,
  FiDollarSign,
  FiFileText,
  FiPhone,
  FiGlobe,
  FiMessageCircle,
  FiCpu,
  FiClock,
  FiBarChart2,
  FiHelpCircle,
  FiImage,
  FiSettings,
  FiLayers,
} from "react-icons/fi";
import { useLazyLoad } from "./utils/performanceOptimizer";

const features = [
  {
    icon: <FiGlobe className="text-white text-3xl" />,
    title: "4 loại nội dung đa kênh",
    description: `Tạo bài đăng MXH, website, blog, nội dung email marketing`,
  },
  {
    icon: <FiStar className="text-white text-3xl" />,
    title: "6 phong cách viết linh hoạt",
    description:
      "Chuyên nghiệp – Sáng tạo – Hài hước – Bán hàng – Kể chuyện – Truyền cảm hứng.",
  },
  {
    icon: <FiImage className="text-white text-3xl" />,
    title: "Tự động tạo ảnh minh hoạ",
    description: "Ảnh minh hoạ phù hợp nội dung và kênh đăng tải.",
  },
  {
    icon: <FiClock className="text-white text-3xl" />,
    title: "Tự đăng bài & Đặt lịch tự động",
    description:
      "Đăng bài lên Fanpage, đặt lịch tự động, tiết kiệm thời gian và tối ưu hiệu quả marketing.",
  },
];

const targetUsers = [
  "Doanh nghiệp vừa & nhỏ (BĐS, tài chính, giáo dục, bán lẻ…)",
  "Các nhân viên kinh doanh, chuyên viên marketing",
  "Chủ shop kinh doanh online",
  "Influencer & Content Creator",
  "Bất kì ai cần tạo nội dung Nhiều – Nhanh – Chất Lượng Cao",
];

const pricing = [
  {
    name: "Gói 7 ngày",
    price: "39.000 đ",
    note: "",
    discount: "",
  },
  {
    name: "Gói 30 ngày",
    price: "169.000 đ",
    note: "chỉ 139.000 đ",
    discount: "giảm 20%",
  },
  {
    name: "Gói 180 ngày",
    price: "1.000.000 đ",
    note: "chỉ 649.000 đ",
    discount: "giảm 35%",
  },
  {
    name: "Gói 360 ngày",
    price: "2.000.000 đ",
    note: "chỉ 999.000 đ",
    discount: "giảm 50%",
  },
];

const companyInfo = [
  "CT Global Holdings là tập đoàn được thành lập ngày 10/10/2019 tại Singapore, giấy phép kinh doanh số 201934143N và có địa chỉ tại 160 Robinson Road, #14-04, Singapore (068914). Tập đoàn hoạt động chính trong các lĩnh vực đầu tư, công nghệ ứng dụng và bất động sản.",
  "Tại Việt Nam, công ty TNHH CT Toàn Cầu (công ty 100% thuộc CT Global Holdings), mã số thuế 0108591862, đăng kí kinh doanh tại địa chỉ tòa Hồ Gươm Plaza, số 102 Trần Phú, Hà Đông, Hà Nội.",
  "Công ty là chủ sở hữu thương hiệu và nền tảng YouHomes, ứng dụng cung cấp dịch vụ toàn diện, được tích hợp AI và bigdata, bao gồm:",
  "+ Hệ thống quản trị tuỳ biến theo doanh nghiệp (White-labeled Operating System), có tên thương mại là bPRO, giúp tối ưu hóa công việc quản trị vận hành với bộ ứng dụng quản lý khách hàng CRM, quản lý danh mục bất động sản IMS…",
  "+ Trung tâm AI (AICenter) giúp tự động hóa công việc Marketing, tăng X10 hiệu quả thu hút và tiếp cận khách hàng với AICenter, với trọn bộ công cụ AI mà người kinh doanh bán lẻ cần có như công cụ post bài hàng loạt & tự động tìm khách trên facebook (AIToolFB), công cụ tạo video tức thời (AIVideo), tạo nội dung tự động (AIContent), …",
  "+ Trung tâm dữ liệu lớn (Bigdata Powerhouse) giúp người dùng khai thác và vận dụng nguồn nhằm tối ưu hoạt động kinh doanh",
  "Ngoài ra, công ty cũng hoạt động trong các lĩnh vực đầu tư, phát triển dự án và xây dựng, kinh doanh sản phẩm phần mềm, ứng dụng công nghệ AI.",
];

const contactInfo = [
  {
    label: "Hotline",
    value: "0886399781",
    icon: <FiPhone className="text-blue-500 text-xl" />,
  },
  {
    label: "Email",
    value: "contact@youhomes.vn",
    icon: <FiMessageCircle className="text-blue-500 text-xl" />,
  },
  {
    label: "Website",
    value: "https://aicontent.youhomes.vn",
    icon: <FiGlobe className="text-blue-500 text-xl" />,
  },
  {
    label: "Zalo",
    value: "0886399781",
    icon: (
      <svg
        className="text-blue-500 w-5 h-5"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M12.49 10.272v-.45h1.347v6.322h-1.347v-.453c0-.016 0-.032-.003-.048a.171.171 0 00-.028-.086.208.208 0 00-.068-.07c-.384-.242-.816-.414-1.263-.54a6.554 6.554 0 00-1.938-.263 6.725 6.725 0 00-2.14.343c-.696.227-1.336.57-1.87 1.03a4.797 4.797 0 00-1.258 1.59c-.298.608-.434 1.264-.425 1.944.009.69.155 1.35.465 1.96a4.877 4.877 0 001.303 1.577c.558.45 1.193.783 1.883 1.001.68.217 1.394.322 2.116.322.803 0 1.591-.134 2.346-.398a6.236 6.236 0 002.1-1.235l.96 1.034a8.71 8.71 0 01-1.333.826 7.426 7.426 0 01-1.439.54 8.602 8.602 0 01-1.504.263 10.875 10.875 0 01-1.508.033 7.437 7.437 0 01-2.535-.494 6.55 6.55 0 01-2.161-1.4 6.722 6.722 0 01-1.513-2.145 6.424 6.424 0 01-.455-4.878 6.452 6.452 0 011.492-2.147 7.34 7.34 0 012.284-1.43 7.785 7.785 0 012.798-.494c.324 0 .656.019.99.058.329.038.654.098.97.178.314.08.618.184.91.31.292.124.561.274.814.45a.224.224 0 00.089.026.114.114 0 00.07-.026.171.171 0 00.052-.066.192.192 0 00.02-.089zm-1.337 2.304c-.325-.203-.695-.351-1.095-.45a5.25 5.25 0 00-1.26-.142c-.696 0-1.336.115-1.883.351a3.753 3.753 0 00-1.373.941c-.371.396-.66.853-.85 1.359-.193.505-.285 1.042-.285 1.597 0 .536.092 1.055.285 1.542.19.488.47.928.841 1.306.371.378.825.681 1.347.898.522.217 1.115.33 1.765.33.487 0 .946-.066 1.364-.196.417-.13.79-.312 1.115-.54.324-.23.594-.505.805-.816.21-.312.337-.653.37-1.017h1.346a4.4 4.4 0 01-.493 1.587 4.08 4.08 0 01-1.08 1.288c-.461.366-1.006.648-1.624.844-.618.196-1.301.297-2.042.297-.867 0-1.661-.142-2.364-.423a5.493 5.493 0 01-1.856-1.172 5.211 5.211 0 01-1.213-1.79c-.29-.687-.432-1.434-.432-2.233 0-.79.142-1.527.432-2.205.288-.678.687-1.27 1.195-1.764a5.616 5.616 0 011.847-1.19c.72-.29 1.513-.437 2.364-.437.487 0 .961.049 1.418.15.456.1.88.246 1.266.432.387.185.739.41 1.054.673.315.262.576.55.779.862l-1.328.755a3.56 3.56 0 00-.761-.755z" />
      </svg>
    ),
  },
  {
    label: "Facebook",
    value: "https://facebook.com/aicontent",
    icon: (
      <svg
        className="text-blue-500 w-5 h-5"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
      </svg>
    ),
  },
];

const problemPoints = [
  {
    icon: <FiHelpCircle className="text-red-500 text-3xl" />,
    title: "Bí ý tưởng, nội dung kém hấp dẫn",
    description: "Nội dung thiếu sáng tạo, khó thuyết phục khách hàng mua hàng",
  },
  {
    icon: <FiGlobe className="text-red-500 text-3xl" />,
    title: "Fanpage/website không thu hút",
    description:
      "Nội dung nhàm chán, không cập nhật thường xuyên, làm khách bỏ đi",
  },
  {
    icon: <FiClock className="text-red-500 text-3xl" />,
    title: "Tốn quá nhiều thời gian",
    description:
      "Mỗi ngày mất hàng giờ để nghĩ ý tưởng, viết bài, sửa ảnh, đăng bài thủ công",
  },
  {
    icon: <FiLayers className="text-red-500 text-3xl" />,
    title: "Không duy trì đăng bài đều đặn",
    description: "Khiến lượng tương tác sụt giảm, giảm tỉ lệ chốt đơn",
  },
  {
    icon: <FiDollarSign className="text-red-500 text-3xl" />,
    title: "Chi phí marketing quá cao",
    description:
      "Thuê đội ngũ marketing, viết bài, thiết kế, quản lý fanpage tốn kém",
  },
  {
    icon: <FiSettings className="text-red-500 text-3xl" />,
    title: "Công cụ quá phức tạp, khó dùng",
    description:
      "Nhiều công cụ marketing hiên tại phức tạp, tốn thời gian học và sử dụng không hiệu quả",
  },
];

const solutionPoints = [
  {
    icon: <FiCpu className="text-white text-3xl" />,
    title: "AI Tạo Nội Dung Đa Kênh",
    description:
      "Công nghệ AI tiên tiến phân tích và tạo nội dung tối ưu cho cả Fanpage (ngắn gọn, tương tác cao) và Website (chi tiết, chuẩn SEO)",
  },
  {
    icon: <FiClock className="text-white text-3xl" />,
    title: "Tự động đăng bài đa nền tảng",
    description:
      "Lên lịch và tự động đăng bài lên cả Fanpage và Website. Tối ưu thời điểm để tăng tương tác và traffic, không cần thao tác thủ công",
  },
  {
    icon: <FiBarChart2 className="text-white text-3xl" />,
    title: "Tiết kiệm thời gian và chi phí",
    description:
      "Giảm hơn 80% thời gian quản lý content và chi phí nhân sự cho cả Fanpage và Website",
  },
];

const testimonials = [
  {
    quote:
      "Trước kia đội marketing của tôi mất cả tuần để lên ý tưởng và sản xuất nội dung cho từng đợt mở bán. Nhưng từ khi có AIContent, mọi thứ trở nên cực kỳ đơn giản: bài viết, hình ảnh đều có ngay chỉ trong vài phút! Tôi tiết kiệm được hơn 70% chi phí mà chất lượng content vẫn rất đẳng cấp.",
    name: "Phạm Gia Bảo",
    position: "Chủ đầu tư dự án biệt thự nghỉ dưỡng",
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    quote:
      "Tôi đã thử nhiều công cụ AI khác nhau nhưng AIContent tạo nội dung chuẩn nhất, đúng tone brand. Chúng tôi đã gia hạn thêm 1 năm sau khi sử dụng được 3 tháng vì hiệu quả quá rõ rệt.",
    name: "Trần Đức Minh",
    position: "CEO, Công ty Bất động sản Đức Minh",
    avatar: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    quote:
      "Từ khi sử dụng AIContent, lượng tương tác trên fanpage của chúng tôi tăng 300% và traffic website tăng 150%. Chi phí thuê nhân sự content cũng giảm đáng kể, từ 3 người xuống còn 1.",
    name: "Nguyễn Minh Tuấn",
    position: "Chủ chuỗi cửa hàng mỹ phẩm Minh Tuấn",
    avatar: "https://randomuser.me/api/portraits/men/67.jpg",
  },
  {
    quote:
      "AIContent giúp chúng tôi tạo nội dung bán hàng với tần suất gấp 5 lần so với trước đây. Tỷ lệ chuyển đổi từ fanpage tăng 27%. Đây là công cụ không thể thiếu với bất kỳ doanh nghiệp online nào.",
    name: "Phạm Thị Huyền",
    position: "Founder, Thời trang Bella Fashion",
    avatar: "https://randomuser.me/api/portraits/women/23.jpg",
  },
  {
    quote:
      "Tôi từng phải trả 8 triệu/tháng cho nhân viên viết content mà chất lượng không đều. Với AIContent, tôi chỉ mất 999k/năm mà lại có nội dung đa dạng, chất lượng cao và đều đặn hàng ngày.",
    name: "Phan Thành Trung",
    position: "Giám đốc, Công ty Du lịch Việt Travel",
    avatar: "https://randomuser.me/api/portraits/men/15.jpg",
  },
  {
    quote:
      "Là một người không có khả năng viết lách, AIContent đã cứu cả việc kinh doanh của tôi. Giờ đây shop online của tôi có nội dung chuyên nghiệp không kém gì các thương hiệu lớn.",
    name: "Ngô Thị Ánh Nguyệt",
    position: "Chủ shop, MomBaby.vn",
    avatar: "https://randomuser.me/api/portraits/women/65.jpg",
  },
];

const passiveIncomeFeatures = [
  "Tự động tạo nội dung đa kênh",
  "Tự động đăng bài lên nhiều nền tảng",
  "Tự động tạo ảnh minh họa chất lượng cao",
  "Lên lịch đăng bài thông minh",
  "Phân tích hiệu suất nội dung",
  "Tối ưu hóa SEO tự động",
];

const SEO = () => (
  <Helmet>
    <html lang="vi" />
    <title>
      AIContent – Công cụ tạo nội dung tự động bằng AI cho MXH, Web, Blog, Email
    </title>
    <meta
      name="description"
      content="AIContent là công cụ AI hỗ trợ bạn tạo ra nội dung chất lượng cao, chuẩn SEO chỉ trong vài giây – không cần kỹ năng viết lách hay thiết kế."
    />
    <meta
      name="keywords"
      content="AIContent, AI viết content, tạo nội dung tự động, content marketing, AI cho doanh nghiệp"
    />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
  </Helmet>
);

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);

  const handleTryNow = React.useCallback(() => {
    // Track the click event with Meta Pixel
    trackEvent("TryNowClick", { button_location: "header" });

    // Also track with Firebase Analytics
    trackButtonClick("try_now_header");

    const userAccessToken = localStorage.getItem("userAccessToken");
    const userId = localStorage.getItem("userId");
    const authMethod = localStorage.getItem("authMethod");

    console.log("🔍 handleTryNow - Debug info:", {
      userAccessToken: !!userAccessToken,
      userId: !!userId,
      authMethod,
      tokenValue: userAccessToken,
    });

    if (userAccessToken && userId) {
      console.log("🔄 User authenticated, redirecting to /normal-post");
      window.location.href = "/normal-post";
    } else {
      console.log("🔄 User not authenticated, redirecting to login");
      window.location.href = "/login?returnUrl=/normal-post";
    }
  }, []);

  const menuItems = [
    { name: "Trang Chủ", icon: <FiHome className="mr-2" />, href: "#" },
    { name: "Tính Năng", icon: <FiStar className="mr-2" />, href: "#features" },
    { name: "Liên Hệ", icon: <FiPhone className="mr-2" />, href: "#contact" },
  ];

  return (
    <header className="bg-[#14389F] text-white py-2 shadow-md sticky top-0 z-50">
      <div className="container mx-auto flex justify-between items-center px-4">
        <a href="/" className="flex items-center gap-3 font-bold text-2xl">
          <img
            src={require("./images/logo_AIContent.png")}
            alt="AIContent Logo"
            className="h-16 w-auto"
            loading="lazy"
          />
          <span className="text-3xl font-bold">AIContent</span>
        </a>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-8">
          <nav>
            <ul className="flex space-x-8">
              {menuItems.map((item, index) => (
                <li key={index}>
                  <a
                    href={item.href}
                    className="hover:text-yellow-300 transition flex items-center text-base font-medium"
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="flex items-center gap-5">
            <LanguageSelector isInHeader={true} />
            <button
              onClick={handleTryNow}
              className="bg-yellow-400 text-gray-900 px-5 py-3 rounded-full font-semibold hover:bg-yellow-300 transition text-base"
            >
              Đăng ký ngay
            </button>
          </div>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden flex items-center gap-4">
          <LanguageSelector isInHeader={true} />
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-white focus:outline-none"
          >
            <svg
              className="w-7 h-7"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isMobileMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-blue-800 mt-2 py-4 px-4">
          <nav>
            <ul className="space-y-3">
              {menuItems.map((item, index) => (
                <li key={index}>
                  <a
                    href={item.href}
                    className="hover:text-yellow-300 transition flex items-center text-base font-medium py-2"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {item.icon}
                    {item.name}
                  </a>
                </li>
              ))}
              <li className="pt-2 mt-2 border-t border-blue-700">
                <button
                  onClick={() => {
                    setIsMobileMenuOpen(false);
                    handleTryNow();
                  }}
                  className="bg-yellow-400 text-gray-900 px-5 py-3 rounded-full font-semibold hover:bg-yellow-300 transition inline-block text-base"
                >
                  Đăng ký ngay
                </button>
              </li>
            </ul>
          </nav>
        </div>
      )}
    </header>
  );
};

const HeroSection = () => {
  const handleTryNow = () => {
    // Track the click event with Meta Pixel
    trackEvent("TryNowClick", { button_location: "hero_section" });

    // Also track with Firebase Analytics
    trackButtonClick("try_now_button", { location: "hero_section" });

    const userAccessToken = localStorage.getItem("userAccessToken");
    const userId = localStorage.getItem("userId");

    if (userAccessToken && userId) {
      window.location.href = "/normal-post";
    } else {
      window.location.href = "/login?returnUrl=/normal-post";
    }
  };

  return (
    <section className="bg-gradient-to-b from-blue-700 to-blue-500 text-white py-20">
      <div className="container mx-auto px-8 md:px-32 flex flex-col md:flex-row items-center gap-12">
        <div className="md:w-1/2 space-y-6">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="block">AIContent – Công cụ tạo</span>
            <span className="highlight-text bg-clip-text text-transparent bg-gradient-to-r from-yellow-300 via-yellow-200 to-yellow-100">
              content tự động bằng AI
            </span>
            <span className="block text-2xl md:text-3xl mt-2">
              cho MXH, Web, Blog, Email
            </span>
          </h1>

          <p className="text-lg md:text-xl">
            Viết nội dung chưa bao giờ dễ dàng đến thế! <br />
            <span className="font-semibold">
              <span className="text-yellow-300">
                AIContent là công cụ AI hỗ trợ bạn tạo ra
              </span>{" "}
              nội dung chất lượng cao, chuẩn SEO chỉ trong vài giây – không cần
              kỹ năng viết lách hay thiết kế.
            </span>
          </p>

          {/* User stats */}
          <div className="flex flex-wrap gap-4 py-2">
            <div className="bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg border border-white/10 flex items-center gap-2">
              <svg
                className="w-5 h-5 text-blue-300"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                  clipRule="evenodd"
                />
              </svg>
              <div>
                <span className="text-2xl font-bold text-white">10,000+</span>
                <span className="text-blue-200 text-sm block">Người dùng</span>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm px-4 py-2 rounded-lg border border-white/10 flex items-center gap-2">
              <svg
                className="w-5 h-5 text-blue-300"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm3 1h6v4H7V5zm8 8v2h1v1H4v-1h1v-2a1 1 0 011-1h8a1 1 0 011 1z"
                  clipRule="evenodd"
                />
              </svg>
              <div>
                <span className="text-2xl font-bold text-white">500+</span>
                <span className="text-blue-200 text-sm block">
                  Doanh nghiệp
                </span>
              </div>
            </div>
          </div>

          <div className="flex flex-wrap gap-4 mt-6">
            <button
              onClick={handleTryNow}
              className="bg-yellow-400 text-gray-900 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:bg-yellow-300 transition"
            >
              Đăng ký ngay
            </button>
          </div>
        </div>

        <div className="md:w-1/2 flex justify-center">
          <img
            src={require("./images/dashboard.webp")}
            alt="Giao diện AIContent"
            className="rounded-2xl shadow-2xl w-full max-w-xl"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

const ProblemSection = () => {
  const [ref, isVisible] = useLazyLoad(0.1);

  return (
    <section id="problems" ref={ref} className="bg-gray-50 py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-gray-800">
          Bạn Đang Gặp Những Vấn Đề Này?
        </h2>
        <p className="text-center text-gray-600 max-w-3xl mx-auto mb-12">
          Hàng triệu doanh nghiệp cũng đang phải đối mặt với những thách thức
          tương tự trong việc sáng tạo nội dung và tăng hiệu quả marketing
          online
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {problemPoints.map((problem, idx) => (
            <div
              key={idx}
              className={`bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 transform ${
                isVisible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-10"
              }`}
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4">
                <div className="bg-red-50 p-3 rounded-full mb-3 sm:mb-0">
                  {problem.icon}
                </div>
                <div className="text-center sm:text-left">
                  <h3 className="text-xl font-bold text-gray-800 mb-2">
                    {problem.title}
                  </h3>
                  <p className="text-gray-600">{problem.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const SolutionSection = () => {
  const [ref, isVisible] = useLazyLoad(0.1);

  return (
    <section
      id="solutions"
      ref={ref}
      className="bg-gradient-to-r from-blue-600 to-blue-800 text-white py-16"
    >
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
          Giải Pháp Tự Động Hoá Nội Dung Toàn Diện AIContent
        </h2>
        <p className="text-center text-blue-100 max-w-3xl mx-auto mb-12">
          AIContent cung cấp giải pháp toàn diện giúp tự động hoá hoàn toàn quy
          trình tạo và đăng nội dung chất lượng
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {solutionPoints.map((solution, idx) => (
            <div
              key={idx}
              className={`bg-white/10 backdrop-blur-sm p-8 rounded-xl border border-white/20 hover:bg-white/20 transition-all duration-300 transform ${
                isVisible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-10"
              }`}
              style={{ transitionDelay: `${idx * 150}ms` }}
            >
              <div className="flex flex-col items-center text-center">
                <div className="bg-blue-500/30 p-4 rounded-full mb-6 border border-blue-300/30">
                  {solution.icon}
                </div>
                <h3 className="text-xl font-bold mb-4">{solution.title}</h3>
                <p className="text-blue-100">{solution.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="#features"
            className="inline-block bg-white text-blue-700 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:bg-blue-50 transition"
          >
            Xem Chi Tiết
          </a>
        </div>
      </div>
    </section>
  );
};

const FeaturesSection = () => {
  const [ref, isVisible] = useLazyLoad(0.1);

  return (
    <section
      id="features"
      ref={ref}
      className="bg-white py-16 relative overflow-hidden"
    >
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute top-0 left-0 w-64 h-64 bg-blue-500 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-64 h-64 bg-yellow-500 rounded-full translate-x-1/2 translate-y-1/2 blur-3xl"></div>
      </div>
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-blue-700 relative inline-block">
            Tính năng nổi bật
            <div className="absolute -bottom-2 left-0 right-0 h-1 bg-gradient-to-r from-blue-400 to-blue-600 rounded-full"></div>
          </h2>
          <p className="text-gray-600 mt-4">
            Khám phá các công cụ mạnh mẽ giúp bạn tự động hóa hoàn toàn quy
            trình tạo nội dung
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((f, idx) => (
            <div
              key={idx}
              className={`bg-blue-50 rounded-xl p-8 shadow hover:shadow-lg transition transform ${
                isVisible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-10"
              }`}
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <div className="flex flex-col items-center mb-4">
                <div className="bg-gradient-to-r from-blue-600 to-blue-700 w-16 h-16 rounded-full flex items-center justify-center mb-4 shadow-lg shadow-blue-200">
                  {f.icon}
                </div>
                <h3 className="text-xl font-semibold text-blue-900 mb-3 text-center border-b-2 border-blue-100 pb-2 inline-block">
                  {f.title}
                </h3>
              </div>
              <p className="text-gray-700 text-center">{f.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const TargetUsersSection = () => {
  const [ref, isVisible] = useLazyLoad(0.1);

  return (
    <section
      id="target-users"
      ref={ref}
      className="bg-gradient-to-r from-blue-100 to-blue-50 py-16"
    >
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 text-blue-800">
          AIContent phù hợp với ai?
        </h2>
        <ul className="max-w-2xl mx-auto space-y-4 text-lg">
          {targetUsers.map((user, idx) => (
            <li
              key={idx}
              className={`flex items-center gap-3 transform transition-all duration-300 ${
                isVisible
                  ? "opacity-100 translate-x-0"
                  : "opacity-0 -translate-x-10"
              }`}
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <span className="inline-block w-3 h-3 bg-blue-500 rounded-full"></span>
              {user}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

const ClientLogos = () => (
  <div className="py-8 bg-white">
    <div className="container mx-auto px-4">
      <p className="text-center text-gray-500 mb-6 text-sm font-medium uppercase tracking-wider">
        Được tin dùng bởi các doanh nghiệp hàng đầu
      </p>
      <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16">
        {/* Placeholder logos - Thay thế bằng logo thực tế */}
        <div className="w-24 h-12 bg-gray-200 rounded flex items-center justify-center text-gray-500 font-semibold">
          Logo 1
        </div>
        <div className="w-24 h-12 bg-gray-200 rounded flex items-center justify-center text-gray-500 font-semibold">
          Logo 2
        </div>
        <div className="w-24 h-12 bg-gray-200 rounded flex items-center justify-center text-gray-500 font-semibold">
          Logo 3
        </div>
        <div className="w-24 h-12 bg-gray-200 rounded flex items-center justify-center text-gray-500 font-semibold">
          Logo 4
        </div>
        <div className="w-24 h-12 bg-gray-200 rounded flex items-center justify-center text-gray-500 font-semibold">
          Logo 5
        </div>
      </div>
    </div>
  </div>
);

const TestimonialsSection = () => {
  const [ref, isVisible] = useLazyLoad(0.1);

  return (
    <section id="testimonials" ref={ref} className="bg-gray-50 py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-blue-700">
          Khách Hàng Nói Gì Về Chúng Tôi?
        </h2>
        <p className="text-center text-gray-600 max-w-3xl mx-auto mb-12">
          +500 doanh nghiệp và +10.000 người dùng đã tin tưởng và sử dụng
          AIContent để tự động hoá nội dung marketing
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto">
          {testimonials.map((testimonial, idx) => (
            <div
              key={idx}
              className={`bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 transform ${
                isVisible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-10"
              }`}
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <div className="flex flex-col h-full">
                <div className="mb-4">
                  <svg
                    className="w-8 h-8 text-blue-400"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                  </svg>
                </div>

                <p className="text-gray-700 mb-6 flex-grow">
                  "{testimonial.quote}"
                </p>

                <div className="flex flex-col sm:flex-row items-center sm:items-start mt-auto">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full mb-3 sm:mb-0 sm:mr-4 object-cover"
                    loading="lazy"
                  />
                  <div className="text-center sm:text-left">
                    <h4 className="font-bold text-gray-800">
                      {testimonial.name}
                    </h4>
                    <p className="text-gray-600 text-sm">
                      {testimonial.position}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const ProductivitySection = () => {
  const [ref] = useLazyLoad(0.1);

  const handleTryNow = () => {
    // Track the click event with Meta Pixel
    trackEvent("TryNowClick", { button_location: "productivity_section" });

    // Also track with Firebase Analytics
    trackButtonClick("try_now_button", { location: "productivity_section" });

    const userAccessToken = localStorage.getItem("userAccessToken");
    const userId = localStorage.getItem("userId");

    if (userAccessToken && userId) {
      window.location.href = "/normal-post";
    } else {
      window.location.href = "/login?returnUrl=/normal-post";
    }
  };

  return (
    <section id="productivity" ref={ref} className="bg-white py-12">
      <div className="container mx-auto px-4 text-center max-w-4xl">
        <h2 className="text-2xl md:text-3xl font-bold mb-4 text-blue-700">
          Tối ưu năng suất – Tăng trưởng bền vững cùng AI
        </h2>
        <p className="text-lg mb-4">
          Bạn không cần đội content. Bạn không cần thuê designer.
          <br />
          <span className="font-semibold">
            Bạn chỉ cần AIContent để vận hành toàn bộ quy trình nội dung: Tự
            động – Nhanh chóng – Hiệu quả.
          </span>
        </p>
        <p className="text-base text-gray-700">
          Bắt đầu sử dụng AIContent chỉ trong 30 giây!
        </p>

        <p className="mt-3 text-base text-gray-700 bg-yellow-50 p-4 rounded-lg border border-yellow-200">
          🎁 ĐĂNG KÝ NGAY và hãy để AIContent tự động tạo ra cho bạn hàng nghìn
          nội dung marketing bán hàng hấp dẫn, giúp tăng thu hút khách hàng và
          đột phá kết quả kinh doanh.
          <br />
          <br />
          👉 Đăng ký tại{" "}
          <a
            href="https://aicontent.youhomes.vn"
            className="text-blue-600 font-medium hover:underline"
          >
            https://aicontent.youhomes.vn
          </a>{" "}
          hoặc liên hệ hotline{" "}
          <a
            href="tel:0886399781"
            className="text-blue-600 font-medium hover:underline"
          >
            0886399781
          </a>{" "}
          để được hỗ trợ
        </p>

        <button
          onClick={handleTryNow}
          className="mt-6 inline-block bg-yellow-400 text-gray-900 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:bg-yellow-300 transition"
        >
          Đăng ký ngay
        </button>
      </div>
    </section>
  );
};

const PassiveIncomeSection = () => {
  const [ref, isVisible] = useLazyLoad(0.1);

  const handleTryNow = () => {
    // Track the click event with Meta Pixel
    trackEvent("TryNowClick", { button_location: "passive_income_section" });

    // Also track with Firebase Analytics
    trackButtonClick("try_now_button", { location: "passive_income_section" });

    const userAccessToken = localStorage.getItem("userAccessToken");
    const userId = localStorage.getItem("userId");

    if (userAccessToken && userId) {
      window.location.href = "/normal-post";
    } else {
      window.location.href = "/login?returnUrl=/normal-post";
    }
  };

  return (
    <section
      id="passive-income"
      ref={ref}
      className="bg-gradient-to-r from-blue-700 to-indigo-800 text-white py-16"
    >
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          <div
            className={`space-y-6 transform transition-all duration-500 ${
              isVisible
                ? "opacity-100 translate-x-0"
                : "opacity-0 -translate-x-10"
            }`}
          >
            <h2 className="text-3xl md:text-4xl font-bold">
              Trào Giải Pháp Hay, Nhận Ngay Thu Nhập
            </h2>
            <p className="text-xl text-blue-100">
              AIContent không chỉ giúp bạn tự động hóa nội dung mà còn tạo thu
              nhập thụ động không giới hạn
            </p>

            <h3 className="text-2xl font-semibold mt-8 mb-4 text-yellow-300">
              Thu Nhập Thụ Động Không Giới Hạn
            </h3>

            <div className="bg-blue-600/30 p-4 rounded-lg border border-blue-400/30 mb-6">
              <p className="text-white mb-2">
                <span className="font-bold text-yellow-300 text-lg">
                  Tăng doanh thu lên đến 200%
                </span>{" "}
                với nội dung được tạo tự động, tối ưu cho chuyển đổi và SEO.
              </p>
              <p className="text-blue-100">
                Khách hàng của chúng tôi đã tiết kiệm trung bình 15 giờ mỗi tuần
                và tăng 3x lượng truy cập website.
              </p>
            </div>

            <ul className="space-y-3">
              {passiveIncomeFeatures.map((feature, idx) => (
                <li
                  key={idx}
                  className="flex items-center gap-3"
                  style={{ transitionDelay: `${idx * 100 + 300}ms` }}
                >
                  <svg
                    className="w-6 h-6 text-green-400 flex-shrink-0"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                  <span>{feature}</span>
                </li>
              ))}
            </ul>

            <div className="pt-6">
              <button
                onClick={handleTryNow}
                className="inline-block bg-yellow-400 text-gray-900 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:bg-yellow-300 transition"
              >
                Bắt đầu ngay
              </button>
            </div>
          </div>

          <div
            className={`bg-white/10 backdrop-blur-sm p-8 rounded-xl border border-white/20 transform transition-all duration-500 ${
              isVisible
                ? "opacity-100 translate-x-0"
                : "opacity-0 translate-x-10"
            }`}
          >
            <h3 className="text-2xl font-bold mb-6 text-center">
              Đăng ký dùng thử miễn phí
            </h3>
            <form className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1 text-blue-100">
                  Họ và tên
                </label>
                <input
                  type="text"
                  className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:outline-none focus:ring-2 focus:ring-blue-400"
                  placeholder="Nhập họ tên của bạn"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1 text-blue-100">
                  Email
                </label>
                <input
                  type="email"
                  className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:outline-none focus:ring-2 focus:ring-blue-400"
                  placeholder="email@example.com"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1 text-blue-100">
                  Số điện thoại
                </label>
                <input
                  type="tel"
                  className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:outline-none focus:ring-2 focus:ring-blue-400"
                  placeholder="Nhập số điện thoại"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1 text-blue-100">
                  Gói dịch vụ
                </label>
                <select className="w-full px-4 py-3 rounded-lg bg-white/5 border border-white/10 text-white focus:outline-none focus:ring-2 focus:ring-blue-400">
                  <option value="">Chọn gói dịch vụ</option>
                  <option value="7">Gói 7 ngày - 39.000đ</option>
                  <option value="30">Gói 30 ngày - 139.000đ</option>
                  <option value="180">Gói 180 ngày - 649.000đ</option>
                  <option value="360">Gói 360 ngày - 999.000đ</option>
                </select>
              </div>

              <button
                type="button"
                className="w-full bg-yellow-400 text-gray-900 py-3 px-4 rounded-lg font-bold text-lg hover:bg-yellow-300 transition"
              >
                Đăng ký ngay
              </button>

              <p className="text-sm text-blue-200 text-center mt-4">
                Bạn sẽ được dùng thử miễn phí 3 ngày trước khi thanh toán
              </p>

              {/* Security badges */}
              <div className="mt-6 pt-4 border-t border-white/10">
                <p className="text-xs text-blue-200 text-center mb-3">
                  Thanh toán an toàn & bảo mật
                </p>
                <div className="flex justify-center items-center gap-3">
                  <div className="bg-white/20 p-1 rounded">
                    <svg
                      className="w-8 h-8 text-white"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" />
                    </svg>
                  </div>
                  <div className="bg-white/20 p-1 rounded">
                    <svg
                      className="w-8 h-8 text-white"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z" />
                    </svg>
                  </div>
                  <div className="bg-white/20 p-1 rounded">
                    <svg
                      className="w-8 h-8 text-white"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
                    </svg>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

const PricingSection = () => {
  const handleTryNow = () => {
    // Track the click event with Meta Pixel
    trackEvent("TryNowClick", { button_location: "pricing_section" });

    // Also track with Firebase Analytics
    trackButtonClick("try_now_button", { location: "pricing_section" });

    const userAccessToken = localStorage.getItem("userAccessToken");
    const userId = localStorage.getItem("userId");

    if (userAccessToken && userId) {
      window.location.href = "/normal-post";
    } else {
      window.location.href = "/login?returnUrl=/normal-post";
    }
  };

  return (
    <section className="bg-blue-50 py-16 relative overflow-hidden">
      <div className="container mx-auto px-4 mt-8">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4 text-blue-700">
          Bảng giá chi tiết AIContent
        </h2>
        <p className="text-center text-gray-600 max-w-3xl mx-auto mb-10">
          Chọn gói phù hợp với nhu cầu của bạn và bắt đầu tự động hóa nội dung
          ngay hôm nay
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 max-w-7xl mx-auto">
          {pricing.map((p, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl p-6 shadow text-center border border-blue-100 relative overflow-hidden"
            >
              {p.discount && (
                <div className="absolute -right-12 top-5 bg-red-500 text-white py-1 px-12 transform rotate-45 text-sm font-bold">
                  {p.discount}
                </div>
              )}
              <h3 className="text-xl font-bold mb-4 text-blue-900">{p.name}</h3>
              <div className="mb-4">
                {p.note ? (
                  <>
                    <div className="text-gray-500 line-through mb-1">
                      {p.price}
                    </div>
                    <div className="text-2xl font-bold text-green-600">
                      {p.note}
                    </div>
                  </>
                ) : (
                  <div className="text-2xl font-bold text-yellow-500">
                    {p.price}
                  </div>
                )}
              </div>
              <div className="border-t border-b border-gray-100 py-4 mb-4">
                <ul className="text-gray-700 text-sm space-y-2">
                  <li className="flex items-center justify-start">
                    <svg
                      className="w-4 h-4 mr-2 text-green-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Tạo nội dung đa kênh
                  </li>
                  <li className="flex items-center justify-start">
                    <svg
                      className="w-4 h-4 mr-2 text-green-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Tuỳ chọn phong cách viết bài
                  </li>
                  <li className="flex items-center justify-start">
                    <svg
                      className="w-4 h-4 mr-2 text-green-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Tự động tạo ảnh minh hoạ
                  </li>
                  <li className="flex items-center justify-start">
                    <svg
                      className="w-4 h-4 mr-2 text-green-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Tự động kết nối đăng fanpage
                  </li>
                  <li className="flex items-center justify-start">
                    <svg
                      className="w-4 h-4 mr-2 text-green-500"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    Đặt lịch đăng bài tự động
                  </li>
                </ul>
              </div>
              <button
                className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded-lg transition font-medium"
                onClick={handleTryNow}
              >
                Chọn gói này
              </button>
            </div>
          ))}
        </div>
        <div className="text-center mt-8">
          <button
            onClick={handleTryNow}
            className="bg-yellow-400 text-gray-900 px-8 py-4 rounded-xl font-bold text-lg shadow-lg hover:bg-yellow-300 transition"
          >
            Đăng ký ngay
          </button>
        </div>
      </div>
    </section>
  );
};

const AboutSection = () => (
  <section className="bg-white py-16">
    <div className="container mx-auto px-4 max-w-4xl">
      <h2 className="text-2xl md:text-3xl font-bold mb-6 text-blue-800">
        Giới thiệu CT Global Holdings
      </h2>
      <ul className="space-y-4 text-lg text-gray-800">
        {companyInfo.map((info, idx) => (
          <li key={idx}>{info}</li>
        ))}
      </ul>
    </div>
  </section>
);

const FAQSection = () => {
  const [ref, isVisible] = useLazyLoad(0.1);
  const [openIndex, setOpenIndex] = React.useState(null);

  const faqs = [
    {
      question: "AIContent có thực sự tạo ra nội dung chất lượng cao không?",
      answer:
        "Có, AIContent sử dụng công nghệ AI tiên tiến để tạo ra nội dung chất lượng cao, tự nhiên và phù hợp với thương hiệu của bạn. Nội dung được tạo ra được tối ưu hóa cho SEO và chuyển đổi.",
    },
    {
      question: "Tôi có cần kỹ năng kỹ thuật để sử dụng AIContent không?",
      answer:
        "Không, AIContent được thiết kế để dễ dàng sử dụng cho mọi người, kể cả những người không có kỹ năng kỹ thuật. Giao diện trực quan và hướng dẫn chi tiết giúp bạn dễ dàng tạo nội dung chất lượng cao.",
    },
    {
      question: "AIContent có hỗ trợ tiếng Việt không?",
      answer:
        "Có, AIContent hỗ trợ đầy đủ tiếng Việt và được tối ưu hóa đặc biệt cho thị trường Việt Nam. Nội dung được tạo ra sẽ tự nhiên, đúng ngữ pháp và phù hợp với văn hóa Việt Nam.",
    },
    {
      question: "Tôi có thể hủy đăng ký bất kỳ lúc nào không?",
      answer:
        "Có, bạn có thể hủy đăng ký bất kỳ lúc nào. Chúng tôi không yêu cầu cam kết dài hạn và bạn có thể hủy dịch vụ trước khi chu kỳ thanh toán tiếp theo bắt đầu.",
    },
    {
      question: "AIContent có giới hạn số lượng nội dung tạo ra không?",
      answer:
        "Mỗi gói dịch vụ có giới hạn khác nhau về số lượng nội dung có thể tạo ra hàng tháng. Bạn có thể nâng cấp gói dịch vụ bất kỳ lúc nào nếu cần tạo nhiều nội dung hơn.",
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" ref={ref} className="bg-white py-16">
      <div className="container mx-auto px-4 max-w-4xl">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-blue-700">
          Câu hỏi thường gặp
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className={`border rounded-lg overflow-hidden transition-all duration-300 ${
                isVisible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-10"
              }`}
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <button
                className="flex justify-between items-center w-full p-4 text-left bg-gray-50 hover:bg-gray-100 transition"
                onClick={() => toggleFAQ(idx)}
              >
                <span className="font-medium text-lg text-gray-800">
                  {faq.question}
                </span>
                <svg
                  className={`w-5 h-5 text-blue-600 transform transition-transform ${
                    openIndex === idx ? "rotate-180" : ""
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? "max-h-40" : "max-h-0"
                }`}
              >
                <div className="p-4 bg-white border-t">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const ContactSection = () => {
  const [ref, isVisible] = useLazyLoad(0.1);

  return (
    <section
      id="contact"
      ref={ref}
      className="bg-gradient-to-b from-blue-100 to-white py-16"
    >
      <div className="container mx-auto px-4 max-w-4xl">
        <h2 className="text-2xl md:text-3xl font-bold mb-6 text-blue-800 text-center">
          Liên hệ với chúng tôi
        </h2>
        <p className="text-center text-gray-600 max-w-3xl mx-auto mb-10">
          Chúng tôi luôn sẵn sàng hỗ trợ bạn 24/7. Hãy liên hệ với chúng tôi qua
          các kênh sau
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {contactInfo.map((c, idx) => (
            <div
              key={idx}
              className={`bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 transform ${
                isVisible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-10"
              }`}
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <div className="flex items-start gap-4">
                <div className="bg-blue-100 p-3 rounded-full flex items-center justify-center w-12 h-12 flex-shrink-0">
                  {c.icon}
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-gray-800 mb-1">
                    {c.label}
                  </h3>
                  {c.label === "Website" || c.label === "Facebook" ? (
                    <a
                      href={c.value}
                      className="text-blue-600 hover:underline text-sm md:text-base break-words"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {c.value}
                    </a>
                  ) : c.label === "Hotline" || c.label === "Zalo" ? (
                    <a
                      href={`tel:${c.value}`}
                      className="text-blue-600 hover:underline text-sm md:text-base"
                    >
                      {c.value}
                    </a>
                  ) : c.label === "Email" ? (
                    <a
                      href={`mailto:${c.value}`}
                      className="text-blue-600 hover:underline text-sm md:text-base break-words"
                    >
                      {c.value}
                    </a>
                  ) : (
                    <p className="text-gray-600 text-sm md:text-base">
                      {c.value}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <h3 className="text-xl font-bold text-blue-800 mb-4">
            Kết nối với chúng tôi
          </h3>
          <div className="flex justify-center gap-6">
            <a
              href="#"
              className="bg-blue-600 text-white p-3 rounded-full hover:bg-blue-700 transition"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
              </svg>
            </a>
            <a
              href="#"
              className="bg-blue-400 text-white p-3 rounded-full hover:bg-blue-500 transition"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723 10.054 10.054 0 01-3.127 1.184 4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
              </svg>
            </a>
            <a
              href="#"
              className="bg-red-600 text-white p-3 rounded-full hover:bg-red-700 transition"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M21.582 7.172a2.513 2.513 0 00-1.768-1.768C18.254 5 12 5 12 5s-6.254 0-7.814.404a2.513 2.513 0 00-1.768 1.768C2.014 8.732 2 12 2 12s.014 3.268.418 4.828c.23.857.911 1.538 1.768 1.768C5.746 19 12 19 12 19s6.254 0 7.814-.404a2.513 2.513 0 001.768-1.768C22 15.268 22 12 22 12s0-3.268-.418-4.828zM10 15V9l5.2 3-5.2 3z" />
              </svg>
            </a>
            <a
              href="#"
              className="bg-green-600 text-white p-3 rounded-full hover:bg-green-700 transition"
            >
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

const Footer = () => (
  <footer id="contact" className="bg-[#14389F] text-white py-12">
    <div className="container mx-auto px-4">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
        <div className="flex flex-col items-center">
          <h3 className="text-lg font-bold mb-4 text-center">Sản phẩm</h3>
          <ul className="space-y-2 text-blue-200 text-center w-full">
            <li>
              <a href="#" className="hover:text-white transition">
                AIContent
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-white transition">
                AIToolFB
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-white transition">
                AIVideo
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-white transition">
                bPRO
              </a>
            </li>
          </ul>
        </div>

        <div className="flex flex-col items-center">
          <h3 className="text-lg font-bold mb-4 text-center">Hỗ trợ</h3>
          <ul className="space-y-2 text-blue-200 text-center w-full">
            <li>
              <a href="#" className="hover:text-white transition">
                Hướng dẫn sử dụng
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-white transition">
                Câu hỏi thường gặp
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-white transition">
                Liên hệ hỗ trợ
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-white transition">
                Chính sách bảo mật
              </a>
            </li>
          </ul>
        </div>

        <div className="flex flex-col items-center">
          <h3 className="text-lg font-bold mb-4 text-center">Liên hệ</h3>
          <ul className="space-y-2 text-blue-200 text-center w-full">
            <li className="flex items-center justify-center">
              <FiPhone className="mr-2" /> 0886399781
            </li>
            <li className="flex items-center justify-center">
              <FiMessageCircle className="mr-2" /> contact@youhomes.vn
            </li>
            <li className="flex items-center justify-center">
              <FiGlobe className="mr-2" /> aicontent.youhomes.vn
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-blue-800 pt-6 mt-6 text-center">
        <p>
          © {new Date().getFullYear()} AIContent – Công cụ tạo content tự động
          bằng AI. Một sản phẩm của CT Global Holdings.
        </p>
        <div className="mt-4 flex justify-center space-x-4">
          <a href="#" className="text-blue-300 hover:text-white transition">
            Chính sách bảo mật
          </a>
          <a href="#" className="text-blue-300 hover:text-white transition">
            Điều khoản sử dụng
          </a>
          {/* <a href="#" className="text-blue-300 hover:text-white transition">
            Sitemap
          </a> */}
        </div>
      </div>
    </div>
  </footer>
);

const StickyCTA = () => {
  const [isVisible, setIsVisible] = React.useState(false);

  const handleTryNow = () => {
    // Track the click event with Meta Pixel
    trackEvent("TryNowClick", { button_location: "sticky_cta" });

    // Also track with Firebase Analytics
    trackButtonClick("try_now_button", { location: "sticky_cta" });

    const userAccessToken = localStorage.getItem("userAccessToken");
    const userId = localStorage.getItem("userId");

    if (userAccessToken && userId) {
      window.location.href = "/normal-post";
    } else {
      window.location.href = "/login?returnUrl=/normal-post";
    }
  };

  React.useEffect(() => {
    const handleScroll = () => {
      // Hiển thị nút khi người dùng cuộn xuống 500px
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 transition-all duration-300 transform ${
        isVisible
          ? "translate-y-0 opacity-100"
          : "translate-y-10 opacity-0 pointer-events-none"
      }`}
    >
      <button
        onClick={handleTryNow}
        className="bg-yellow-400 text-gray-900 px-4 py-3 rounded-full font-bold shadow-lg hover:bg-yellow-300 transition flex items-center gap-2"
      >
        <span>Đăng ký ngay</span>
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </button>
    </div>
  );
};

const LandingPage2 = () => {
  // Thêm useEffect để scroll đến phần tương ứng khi URL có hash
  React.useEffect(() => {
    // Xử lý scroll đến phần tương ứng khi URL có hash
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          // Thêm một chút delay để đảm bảo trang đã render xong
          setTimeout(() => {
            window.scrollTo({
              top: element.offsetTop - 80, // Trừ đi chiều cao của header
              behavior: "smooth",
            });
          }, 100);
        }
      }
    };

    // Xử lý khi trang được load
    handleHashChange();

    // Xử lý khi hash thay đổi
    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  return (
    <div className="bg-gray-100 min-h-screen">
      <SEO />
      <Header />
      <main>
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <FeaturesSection />
        <TargetUsersSection />
        {/* <ClientLogos /> */}
        <TestimonialsSection />
        <ProductivitySection />
        {/* <PassiveIncomeSection /> */}
        <PricingSection />
        {/* <FAQSection /> */}
        <AboutSection />
        {/* <ContactSection /> */}
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
};

export default LandingPage2;
